<template>
    <v-col
        :cols="width"
    >
        <v-autocomplete
            :chips="item.props.multiple"
            :deletable-chips="item.props.multiple"
            :disabled="readonly"
            :items="item.props.items"
            :label="item.props.label || (item.props.multiple ? 'Select all that Apply' : 'Please select an option')"
            :multiple="item.props.multiple"
            :name="item.name"
            :rules="rules"
            ref="input"
            v-model="modelData"
            outlined
            :search-input.sync="search"
            @change="search = ''"
        >

            <template v-if="item.props.tooltip" v-slot:append-outer>
                <v-tooltip
                    top
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>
        </v-autocomplete>
    </v-col>
</template>

<script>
    export default {
        name: 'Autocomplete',
        props: ['item', 'value', 'readonly', 'rules', 'width'],
        data () {
            return {
                search: null
            }
        },
        computed: {
            modelData: {
                get: function () {
                    const props = this.item && this.item.props;
                    const value = this.value;
                    
                    // This handles the formatting if a selectlist changes from single to multiple with existing values
                    if (value !== undefined && props && props.multiple && !Array.isArray(value)) {
                        return [value];
                    }

                    return value;
                },
                set: function (newVal) {
                    const sort = this.item.props && this.item.props.sort;
                    let emitVal = newVal;

                    if (Array.isArray(newVal) && sort) {
                        emitVal = emitVal.sort();

                        if (sort === 'desc') {
                            emitVal.reverse();
                        }
                    }

                    this.$emit('input', emitVal);
                }
            }
        },
        methods: {
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/questionnaire_template/autocomplete.vue